import QuestionRichTextEditor from './QuestionRichTextEditor.component';

export default QuestionRichTextEditor;